const confirmButtonText = {
  id: 'globals.confirm',
};

const description = {
  id: 'cancelByStockOutSuggestionConfirmationDialog.description',
};

const title = {
  id: 'cancelByStockOutSuggestionConfirmationDialog.title',
};

const textIds = {
  confirmButtonText,
  description,
  title,
};

export default textIds;
